import * as Sentry from "@sentry/react";
import { router } from "./router";
import { isLikelyBenignRemoveChildError } from "./lib/benign-dom-errors";

Sentry.init({
  dsn: "https://24e4b430fa6200a37ad87f2a2348622d@sentry-new.thds.tech/6",
  tunnel: "/shop/api/v1/sentry",
  sendDefaultPii: true,
  beforeSend(event, hint) {
    if (isLikelyBenignRemoveChildError(hint.originalException)) {
      event.tags = {
        ...event.tags,
        benign_dom_candidate: "true",
      };
    }
    return event;
  },
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.tanstackRouterBrowserTracingIntegration(router),
    Sentry.rewriteFramesIntegration({
      root: "https://my.langguth.com/shop/",
    }),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [/^\/shop\/api\/v1/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  release: import.meta.env.VITE_SENTRY_RELEASE,
});

if (typeof window !== "undefined") {
  window.addEventListener(
    "error",
    (event) => {
      if (isLikelyBenignRemoveChildError(event.error)) {
        event.preventDefault();
        if (import.meta.env.DEV) {
          console.warn(
            "[app] Suppressed benign DOM error in window error listener",
            event.error
          );
        }
      }
    },
    true
  );
}
